import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {CursorTarget} from '@wonderlandengine/components';
import type {GameAnalytics as GA} from 'gameanalytics';
declare var GameAnalytics: typeof GA;

/**
 * button-play
 */
export class ButtonPlay extends Component {
    static TypeName = 'button-play';

    @property.string('PrototypeMap.bin')
    url: string = 'PrototypeMap.bin';

    start() {
        const target = this.object.getComponent(CursorTarget)!;
        target.onClick.add(() => {
            GameAnalytics.addDesignEvent('game:button-play');
            this.engine.scene.load(this.url);
        });
    }
}
